export default {
    skipSchema: true,
};
